import { JsonApiModelConfig, JsonApiModel, Attribute, HasMany, BelongsTo } from 'angular2-jsonapi';
import {Address} from "./address";
import {Report} from "./report";
import * as moment from "moment";
import {Customer} from "./customer";
import {Site} from "./site";

@JsonApiModelConfig({
  type: 'appointment'
})
export class Appointment extends JsonApiModel {

  @Attribute()
  date_time: Date;

  @Attribute()
  duration: number;

  @BelongsTo()
  report: Report = null;

  @BelongsTo()
  site: Site;

  @Attribute()
  on_site: boolean;

  get calendarEvent() {
    {
      let title =this.site.customer.name;
      if (this.contactPerson != null){
        title += ' - ' + this.contactPerson.name;
      }
      return {
        title: title,
        start: moment(this.date_time),
        end: moment(this.date_time).add(this.duration, 'minutes'),
        id: parseInt(this.id)
      };
    }
  }

  get isInPast() {
    return moment(this.date_time).isBefore(moment());
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/appointment.ts